import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'sportsRoom',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  emptyMessage: "You don't have Rooms, visit the Room section to create one.",
  getURL:'mainHubs/mainHubId/roomsPaginated',
  sessionParams: ['mainHubId'],
  

  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the room.',
    },
  ],
};
